/* eslint-disable @typescript-eslint/promise-function-async */
import { Routes } from '@angular/router';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const ShortModifyRenewalRoutes: Routes = [
  {
    path: RoutePaths.MODIFY_RENEWAL.RENEWAL_DATA.COVERAGES_RENEWAL.route,
    loadChildren: () =>
      import('@pages/policy-data/coverages-renewal/coverages-renewal.module').then(m => m.CoveragesRenewalPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_RENEWAL.RENEWAL_DATA.SUMMARY_RENEWAL.route,
    loadChildren: () =>
      import('@pages/confirm-data/summary-renewal/summary-renewal.module').then(m => m.SummaryRenewalPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_RENEWAL.RENEWAL_DATA.SAVE_QUOTE_RENEWAL.route,
    loadChildren: () =>
      import('@pages/confirm-data/save-quote-renewal/save-quote-renewal.module').then(
        m => m.SaveQuoteRenewalPageModule
      ),
    canActivate: [NavigationGuard],
  },
];
